import { ApiService, HttpMethod } from '../_common/api.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Site } from './models/site.model';
import { SpatialAdjustSettings } from './models/spatial-adjust-settings.model';

@Injectable({
    providedIn: 'root'
})
export class SiteApiService {

    private apiService: ApiService;

    // =========================================================================================================================================================
    // Ctor
    // =========================================================================================================================================================

    constructor(http: HttpClient) {
        this.apiService = new ApiService(http);
    }

    // =========================================================================================================================================================
    // Public Methods - api
    // =========================================================================================================================================================

    getSite(): Observable<Site> {
        return this.apiService.apiRequest<any>(SiteApiService.siteUrl, HttpMethod.Get)
            .pipe(map(site => new Site(site)));
    }

    getSpatialAdjustSettings(): Observable<SpatialAdjustSettings> {
        return this.apiService.apiRequest<any>(SiteApiService.spatialAdjustSettingsUrl, HttpMethod.Get)
            .pipe(map(settings => new SpatialAdjustSettings(settings)));
    }

    updateSpatialAdjustSettings(settings: SpatialAdjustSettings): Observable<boolean> {
        return this.apiService.apiRequest<any>(SiteApiService.getUpdateAdjustSettingsUrl(settings.siteId), HttpMethod.Post, JSON.stringify(settings));
    }

    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================

    private static get baseUrl(): string { return `${ApiService.baseApiUrl}site`; }

    private static get siteUrl(): string { return `${SiteApiService.baseUrl}`; }

    private static get spatialAdjustSettingsUrl(): string { return `${SiteApiService.baseUrl}/current/spatialAdjustSettings`; }

    private static getUpdateAdjustSettingsUrl(id): string { return `${SiteApiService.baseUrl}/updateSpatialAdjustSettings/${id}`; }
}
